import React from 'react';
import PropTypes from 'prop-types';
import {statsUiTexts} from 'data/ui-texts';
import { getText } from 'helpers/text-helper';
import './stats-login.scss';

const StatsLogin = ({languageId, isLoggingIn, email, password, feedback, handleInput, handleLogin}) => {

	return (
		<div className="StatsLogin">
			<div className="StatsLogin-container">
				<div className="StatsLogin-title"><span>{getText(statsUiTexts.loginTitle, languageId)}</span></div>
				<form className="StatsLogin-form" onSubmit={handleLogin}>
					<input
						name="email"
						type="text"
						placeholder={getText(statsUiTexts.email, languageId)}
						autoComplete="section-adminlogin email"
						value={email ? email : ''}
						onChange={(event)=>{handleInput(event);}}
					/>
					<input
						name="password"
						type="password"
						placeholder={getText(statsUiTexts.password, languageId)}
						autoComplete="section-adminlogin password"
						value={password ? password : ''}
						onChange={(event)=>{handleInput(event);}}
					/>
					<input
						className={'Button Button--login' + (isLoggingIn ? ' Button--isLoading' : '')}
						type="submit"
						value={getText(statsUiTexts.login, languageId)}
					/>
					<p className="StatsLogin-errorMessage"><span>{feedback}</span></p>
				</form>
			</div>
		</div>
	);
};

StatsLogin.propTypes = {
	languageId: PropTypes.string.isRequired,
	isLoggingIn: PropTypes.bool.isRequired,
	email: PropTypes.string,
	password: PropTypes.string,
	feedback: PropTypes.string,
	handleLogin: PropTypes.func.isRequired,
	handleInput: PropTypes.func.isRequired
};

export default StatsLogin;